import { AuthProvider } from "./auth/provider/auth-provider";
import { ContentRouter } from "./routes/content-router";

function App() {

  return (

    <AuthProvider>
      <ContentRouter />
    </AuthProvider>
  );
}

export default App;
